import React from 'react';
import { StyleSheet } from 'react-native';

import { Text } from '../uiold';
import { themeColors } from '../uiold/Constants';

export default function NoPermissionMessage() {
  return (
    <Text style={styles.text}>
      {t(
        'Please contact the market manager if you need permission to change this form',
      )}
    </Text>
  );
}

let styles = StyleSheet.create({
  text: {
    fontWeight: '400',
    fontSize: 16,
    color: themeColors.red,
  },
});
